'use strict';

module.exports = {
    INITIAL_TAB: 'initialTab',
    INITIAL_TAB_ERRORS: 'errors'
};